export default __webpack_public_path__ + "static/media/telegram.6f75062a.svg";